import React, { useState } from "react";
import styles from "./searchModal.module.css";
import Button from "components/buttons/button/button";
import BecomeMember from "components/header/member";
import classNames from "classnames";
import { CloseCircleOutlined } from "@ant-design/icons";

export default function SearchModal({ show, onHide, channelId }) {
  const [member, setMember] = useState(false);

  const handleClose = () => {
    onHide(false);
  };

  const handleBecomeMember = () => {
    setMember(true);
    onHide(false);
  };
  return (
    <div
      className={classNames(styles.modalContent, {
        [styles.visible]: show,
      })}
    >
      <div onClick={handleClose} className={styles.close}>
        <CloseCircleOutlined style={{ fontSize: 20, cursor: "pointer" }} />
      </div>

      <div className={styles.btn} onClick={handleBecomeMember}>
        Register Members
      </div>
      {member && <BecomeMember member={member} setMember={setMember} channelId={channelId} />}
    </div>
  );
}
